import axios from "axios";

export default class UserService {

    async getPages(month = '', year = '') {
        try {
            const res = await axios({
                method: 'get',
                url: `dashboard/pages?year=${year}&month=${month}`, // add a new api hear okay tmam teslm
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('auth-token')
                }
            });
            return res;


        } catch (err) {
            return err
        }
    }

}